import { gql, QueryHookOptions, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { useDateRangeState } from "providers/DateRangeProvider";
import { useGetPortfolioData } from "providers/PortfolioProvider";
import { toLongISOString } from "utils/date";
import { TRANSACTION_FIELDS } from "./fragments";
import { PortfolioTransactionsQuery } from "./types";

const TRANSACTIONS_QUERY = gql`
  ${TRANSACTION_FIELDS}
  query GetPortfolioTransactions(
    $startDate: String
    $endDate: String
    $portfolioIds: [String]
  ) {
    portfolios(ids: $portfolioIds) {
      id
      transactions(startDate: $startDate, endDate: $endDate) {
        ...TransactionsFields
      }
    }
  }
`;

export const useGetPortfolioTransactions = (
  portfolioId: string | undefined,
  options?: QueryHookOptions
) => {
  const { startDate, endDate, fetchPolicyString } = useDateRangeState();
  const { getPortfolioIdsByIdAsString } = useGetPortfolioData();
  const { loading, error, data } = useQuery<PortfolioTransactionsQuery>(
    TRANSACTIONS_QUERY,
    {
      variables: {
        portfolioIds: getPortfolioIdsByIdAsString(Number(portfolioId)),
        startDate: toLongISOString(startDate),
        endDate: toLongISOString(endDate),
      },
      ...getFetchPolicyOptions(
        `useGetPortfolioTransactions.${portfolioId}.${fetchPolicyString}`
      ),
      ...options,
    }
  );

  return {
    loading,
    error,
    data: data?.portfolios.flatMap((portfolio) => portfolio.transactions),
  };
};
